module.exports = __webpack_public_path__ + "img/missions-mobile.3beb1534.jpg";